export const environment = process.env.REACT_APP_ENV
export const version = process.env.REACT_APP_VERSION

export const { REACT_APP_LOCALIZATION_BASE_PATH } = process.env

export const { REACT_APP_7NOW_BASE_PATH } = process.env
export const { REACT_APP_7NOW_API_KEY } = process.env

export const { REACT_APP_7REWARDS_BASE_PATH } = process.env
export const { REACT_APP_7REWARDS_CLIENT_ID } = process.env
export const { REACT_APP_7REWARDS_CLIENT_SECRET } = process.env
export const { REACT_APP_7REWARDS_GUEST_CLIENT_ID } = process.env
export const { REACT_APP_7REWARDS_GUEST_CLIENT_SECRET } = process.env
export const { REACT_APP_7REWARDS_PASSWORD_CLIENT_ID } = process.env
export const { REACT_APP_7REWARDS_PASSWORD_CLIENT_SECRET } = process.env
export const { REACT_APP_7NOW_ORDER_STATUS_MAP_KEY } = process.env
export const { REACT_APP_7NOW_ADDRESS_MAP_KEY } = process.env
export const { REACT_APP_7NOW_STRIPE_KEY_LIVE } = process.env
export const { REACT_APP_7NOW_STRIPE_KEY_TEST } = process.env
export const { REACT_APP_LANGUAGE_CHANGE_ENABLE } = process.env
